import { API, graphqlOperation } from "aws-amplify";

import { getUserQuery } from "./graphql/queries";

const getUser = (id) => API.graphql(graphqlOperation(getUserQuery, { id }));

export default getUser;
